import React from "react";
import { Link } from "react-router-dom";
import logos from "../../images/Logos.png";
import logo from "../../images/logo.png";

export const Sidebar = props => {
  const { setLoginType } = props;
  return (
    <div className="login-content">
      <span>
        <Link onClick={() => setLoginType("default")}>
          <img
            src={logo}
            alt="Zatca Committee Members Login"
            className="heyad-logo"
          />
        </Link>
      </span>
      <span>
        <Link onClick={() => setLoginType("default")}>
          <img src={logos} alt="Zatca Committee Members Login" />
        </Link>
      </span>
      <div className="login-content-text">
        <h3>الرؤية</h3>
        <p>نموذج رائد لتمكين العدالة الناجزة</p>
        <h3>الرسالة</h3>
        <p>
          تبني نماذج عمل فعالة لتمكين حل المنازعات بما يساهم في الوصول لبيئة
          قضائية موثوقة
        </p>
      </div>
    </div>
  );
};
